import moment from 'moment';
// 注：货主名称筛选项顺序不能调，代码中有按照该数组第一位来取值
export const selectListItem1 = [
  {
    id: "1",
    label: "货主名称",
    placeholder: "请输入选择货主名称",
    bfield: 'customerName',
    type: "selectFilter",
    spanl: 6,
    single: '1',
    option: [],
    initialVal: '',
    value: ""
  },{
    id: "2",
    label: "外部订单号",
    placeholder: "请输入外部订单号",
    bfield: 'outerOrderId',
    type: "input",
    spanl: 6,
    initialVal: '',
    value: ""
  },{
    id: "3",
    label: "接入时间",
    placeholder: ['选择开始时间','结束时间'],
    bfield: 'planDate',
    type: "dateTimeRange",
    spanl: 12,
    initialVal: ['',''], //值默认当月第一天和当天
    value: ['','']
    // initialVal: [moment().startOf('month').format('YYYY-MM-DD HH:mm:ss'), moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')],
    // value: [moment().startOf('month').format('YYYY-MM-DD HH:mm:ss'), moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')]
  },{
    id: "4",
    label: "客户运单号",
    placeholder: "请输入客户运单号",
    bfield: 'customerWaybillId',
    type: "input",
    spanl: 6,
    initialVal: '',
    value: ""
  },{
    id: "5",
    label: "提货单号",
    placeholder: "请输入提货单号",
    bfield: 'goodsOrderId',
    type: "input",
    spanl: 6,
    initialVal: '',
    value: ""
  }
];
export const selectListItem2 = [
  {
    id: "1",
    label: "货主名称",
    placeholder: "请输入选择货主名称",
    bfield: 'customerName',
    type: "selectFilter",
    spanl: 6,
    single: '1',
    option: [],
    initialVal: '',
    value: ""
  },{
    id: "2",
    label: "外部订单号",
    placeholder: "请输入外部订单号",
    bfield: 'outerOrderId',
    type: "input",
    spanl: 6,
    initialVal: '',
    value: ""
  },{
    id: "3",
    label: "接入时间",
    placeholder: ['选择开始时间','结束时间'],
    bfield: 'planDate',
    type: "dateTimeRange",
    spanl: 12,
    initialVal: ['',''], //值默认当月第一天和当天
    value: ['','']
    // initialVal: [moment().startOf('month').format('YYYY-MM-DD HH:mm:ss'), moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')],
    // value: [moment().startOf('month').format('YYYY-MM-DD HH:mm:ss'), moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')]
  },{
    id: "4",
    label: "客户运单号",
    placeholder: "请输入客户运单号",
    bfield: 'customerWaybillId',
    type: "input",
    spanl: 6,
    initialVal: '',
    value: ""
  },{
    id: "5",
    label: "送货单号",
    placeholder: "请输入送货单号",
    bfield: 'goodsOrderId',
    type: "input",
    spanl: 6,
    initialVal: '',
    value: ""
  }
];

export const selectListItem = [
  {
    id: "1",
    label: "货主名称",
    placeholder: "请输入选择货主名称",
    bfield: 'customerName',
    type: "selectFilter",
    spanl: 6,
    single: '1',
    option: [],
    initialVal: '',
    value: ""
  },{
    id: "2",
    label: "外部订单号",
    placeholder: "请输入外部订单号",
    bfield: 'outerOrderId',
    type: "input",
    spanl: 6,
    initialVal: '',
    value: ""
  },{
    id: "4",
    label: "客户运单号",
    placeholder: "请输入客户运单号",
    bfield: 'customerWaybillId',
    type: "input",
    spanl: 6,
    initialVal: '',
    value: ""
  },{
    id: "5",
    label: "提送货单号",
    placeholder: "请输入提送货单号",
    bfield: 'goodsOrderId',
    type: "input",
    spanl: 6,
    initialVal: '',
    value: ""
  },{
    id: "6",
    label: "订单号",
    placeholder: "请输入订单号",
    bfield: 'orderId',
    type: "input",
    spanl: 6,
    initialVal: '',
    value: ""
  },{
    id: "7",
    label: "提送货类型",
    placeholder: "请选择提送货类型",
    bfield: 'dataType',
    type: "select",
    spanl: 6,
    initialVal: 0,
    value: 0,
    option: [
      {
        label: '全部',
        value: 0
      },{
        label: '提货',
        value: 1
      },{
        label: '送货',
        value: 2
      }
    ]
  },{
    id: "3",
    label: "创建时间",
    placeholder: ['选择开始时间','结束时间'],
    bfield: 'planDate',
    type: "dateTimeRange",
    spanl: 12,
    initialVal: ['',''], //值默认当月第一天和当天
    value: ['','']
    // initialVal: [moment().startOf('month').format('YYYY-MM-DD HH:mm:ss'), moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')],
    // value: [moment().startOf('month').format('YYYY-MM-DD HH:mm:ss'), moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')]
  }
]